<template>
    <div class="flex-1 bg-white rounded-medium p-7 pb-0 md:pb-7">
        <div v-if="!$store.getters.showContactSales">
            <h1 class="font-walsheim text-lg mb-6">Customize your plan</h1>
            <PlanSection class="mb-12"/>

            <AttachmentSection
                attachment-type="addon"
                title="Personalize your plan"
                class="mb-12"
            />
            <AttachmentSection
                attachment-type="charge"
                title="One-time additions"
                has-accordion
            />
        </div>
        <div v-else>
            <ContactSales />
        </div>
    </div>
</template>

<script>
import PlanSection from '@/BuyNow/Components/PlanSection.vue';
import AttachmentSection from '@/BuyNow/Components/AttachmentSection.vue';
import ContactSales from '@/BuyNow/Components/inputs/Groups/ContactSales.vue';

export default {
    data() {
        return {
        };
    },
    components: {
        PlanSection,
        AttachmentSection,
        ContactSales,
    },
    mounted() {
    },
    props: {
    },
    methods: {
    },
    created() {
    },
    computed: {
        selectedPlanId() {
            return this.$store.getters.selectedPlanId;
        },
        lineItems() {
            return [
                ...this.$store.state.cartInfo.selectedAddons,
                ...this.$store.state.cartInfo.selectedCharges,
            ];
        },
        planAttachments() {
            return [
                ...this.$store.getters.selectedPlan.addons,
                ...this.$store.getters.selectedPlan.charges,
            ]
        }
    },
    watch: {
        // Handle text voice edge case
        selectedPlanId(newId) {
            let attachment = this.planAttachments.find(attachment => attachment.itemId.toLowerCase().includes('text-voice'));
            if (attachment.type === 'mandatory' && !this.lineItems.find(item => item.itemId === attachment.itemId)) {
                this.$store.commit('addAttachment', {itemId: attachment.itemId, quantity: attachment.quantity});
            } else if (attachment.type !== 'mandatory') {
                // TODO: Ask if we want to remove text & voice if they switch to max then back to pro OR do we want to add text & voice back to the cart if they remove it, switch to max then back to pro?
                this.$store.commit('removeAttachment', attachment.itemId);
            }
        },
        lineItems(newVal, oldVal) {
            if (
                oldVal.find(item => item.itemId.toLowerCase().includes('text-voice'))
                && !newVal.find(item => item.itemId.toLowerCase().includes('text-voice'))
            ) {
                newVal.forEach(item => {
                    if (item.itemId.toLowerCase().includes('500-additional-message') || item.itemId.toLowerCase().includes('business-line')) {
                        this.$store.commit('removeAttachment', item.itemId);
                    }
                })

            }
        }

    }
};
</script>

<style lang="postcss" scoped>
</style>
